

import { framework_tool,utils_tool,component_tool } from '@/tool'
let {Session} = utils_tool;
import {modelUtils } from '@/utils'
import {  formatAuth } from '@/utils/commonUtils'

import React from 'react';
import { connect } from 'dva';
import RuleForm from './ruleForm';
let { copy } = utils_tool
let { WizCard,WizModal, WizUpload,WizSpin, WizRow, WizButton, WizTypography, WizCopyModal, Wizmessage, WizInput } = component_tool;
let { WizContainer } = framework_tool;

const getParamRecord = (history) => {
    let record = {}
    if (history.location) {
      if (history.location.pathname === '/rule/configureList/ruleConfigureDetailUpd') {
        if (history.location && history.location.record) {
          record = history.location.record
          Session.set('ruleConfigureDetail', record)
        } else {
          record = Session.get('ruleConfigureDetail') || {}
        }
      }
      if (history.location.pathname === '/rule/configureList/ruleConfigureDetailAdd') {
        if (history.location.record) {
          record = history.location.record
          record.channelType = record.channelType || 'create'
          Session.set('examDetailAdd', record)
        } else {
          record = Session.get('examDetailAdd') || {}
        }
      }
    }
    return record
  }
class RuleConfigureDetail extends WizContainer {


    constructor(props) {
        super(props);
        const { history } = props;
        let record = {};
        let pageType = 'add'

        // 如果是编辑页面，则缓存来自列表页的这条记录，避免刷新页面之后字段被销毁。
        if (history.location && history.location.pathname === '/rule/configureList/ruleConfigureDetailUpd') {
            if (history.location && history.location.record) {
              record = history.location.record;
                Session.set('RuleConfigureDetail', record)
            } else {
              record = Session.get('RuleConfigureDetail') || {};
            }
            pageType = 'upd';
        }
        this.state = {
            ruleId:record['id'],
            initialValue:{ }
        }
        this.pageType = pageType;
    }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/rule/configureList/ruleConfigureDetailUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('RuleConfigureDetail', initialValue)
      } else {
        initialValue = Session.get('RuleConfigureDetail') || {};
      }
    }
    if (initialValue.id !=this.state.ruleId) {
      // this.initialValue = initialValue
      this.setState({ruleId:initialValue.id||''})
      this._componentDidMount(initialValue.id)
    }
  }

    _componentDidMount = (ruleId) => {
      if(ruleId||this.state.ruleId){

        this.doAction({
          path: "ruleConfigure/editInfo",
          payload: {
            key: "ruleConfigure@editInfo",
            apiParams: { id:ruleId?ruleId:this.state.ruleId }
          }
        });
      }
  };

  propsAndStateOnChange = {
    ruleConfigureEditInfo: this._initvalue.bind(this),
  //  ruleId:this._ruleIdChange.bind(this),
    ruleConfigureSave:this._save.bind(this)
  }
  // _ruleIdChange(nextProps, nextState){
  //   if(nextState.ruleId){
  //   }
  //   return false;
  // }
  changeRuleId( data){
    //this.state.ruleId = data
    this.doAction({
     path: "ruleConfigure/editInfo",
     payload: {
       key: "ruleConfigure@editInfo",
       apiParams: { id:data}
     }
   });
  }

  _save(nextProps, nextState) {

    if (nextProps.ruleConfigureSave.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/rule/configureList');
    }else if(nextProps.ruleConfigureSave.code == 100101){
      let str = nextProps.ruleConfigureSave.msg
      WizModal.confirm({
        title: str +"，是否跳转到编辑页？",
        onOk: () => {
          nextState['ruleId'] = nextProps.ruleConfigureSave.data
          this.changeRuleId(nextProps.ruleConfigureSave.data)
        },
        onCancel() {
        }
      });
      return false
    } else {
      wizNotice.error('提交失败：' + nextProps.ruleConfigureSave.msg);
    }
    return true;
  }
  _initvalue(nextProps, nextState) {
    if(nextProps.ruleConfigureEditInfo.code === 1){
      const data = nextProps.ruleConfigureEditInfo.data
      nextState['initialValue']['actionType']  = data['actionType']
      nextState['initialValue']['bizType']  = data['bizType']
      nextState['initialValue']['bizId']  = data['bizId']
      nextState['initialValue']['ruleName']  = data['ruleName']
      nextState['initialValue']['bizName']  = data['bizName']
      nextState['initialValue']['authCmd']  = data['authCmd']
      nextState['initialValue']['outputClass']  = data['outputClass']
      nextState['initialValue']['state']  = data['state']
      nextState['manageKey'] = new Date().getTime()
      if(data['outputInfoList'] && data['outputInfoList'] instanceof Array && data['outputInfoList'].length>0){
        nextState['initialValue']['outputClass'] =data['outputInfoList'].map(outputInfo=>outputInfo.outputClass).join(",")
        data['outputInfoList'].forEach(outputInfo=>{
          nextState['initialValue'][`limitType${outputInfo.outputClass}`] = outputInfo['limitType'] || null
          nextState['initialValue'][`outputFlag${outputInfo.outputClass}`] = outputInfo['outputFlag'] || null
          nextState['initialValue'][`outputValue${outputInfo.outputClass}`] = outputInfo['outputValue'] || null
          nextState['initialValue'][`limitCount${outputInfo.outputClass}`] = outputInfo['limitCount'] || null
          nextState['initialValue'][`limitCycleType${outputInfo.outputClass}`] = outputInfo['limitCycleType'] || null
          nextState['initialValue'][`outputFlagName${outputInfo.outputClass}`] = outputInfo['outputFlagName'] || null
          nextState['initialValue'][`outputName${outputInfo.outputClass}`] = outputInfo['outputName'] || null
        })
      }
    }else{
      wizNotice.error(nextProps.ruleConfigureEditInfo.msg);
    }
    return true;
  }
    _submit = (apiParams) => {

    apiParams['authCmd'] = formatAuth(apiParams.authCmd)
      let requestParams = { id:this.state.ruleId ,actionType:apiParams['actionType'],authCmd:apiParams['authCmd'],bizId:apiParams['bizId'],
      ruleName:apiParams['ruleName'],bizType:apiParams['bizType'],state:apiParams['state']}
      let outputInfoList = []
      if(apiParams&&apiParams.outputClass && apiParams.outputClass instanceof Array &&apiParams.outputClass.length>0){
        apiParams.outputClass.map(output=>{
          outputInfoList.push({
            outputClass:output
            ,limitType:apiParams['limitType'+output]
            ,outputFlag:apiParams['outputFlag'+output]
            ,outputValue:apiParams['outputValue'+output]
            ,limitCycleType: this.getZeroIsValue(apiParams['limitCount'+output] ,'limitCycleType')
            ,limitCount:this.getZeroIsValue(apiParams['limitCount'+output] ,'limitNum')
          })
        })
      }
      requestParams['outputInfoList'] =outputInfoList
      this.doAction({
        path: this.pageType === 'add' ? "ruleConfigure/add" : "ruleConfigure/update",
        payload: {
            key: "ruleConfigure@save",
            apiParams:requestParams
        }
    });

  }
  getZeroIsValue(object={},title){
    if(object && (object[title]|| object[title]==0)){
      return object[title];
    }else{
      return null;
    }
  }
    _render() {
     let title =  this.state.ruleId?"修改规则配置":"新增规则配置"
        return (
          <>

            <WizCard>

            <WizSpin tip={"加载中"} spinning={this.props.ruleConfigureLoading }>
                        <RuleForm key = {this.state.ruleId} submit={(v) => { this._submit(v) }} data={this.state.initialValue} manageKey={this.state.manageKey} />
                    </WizSpin>
            </WizCard>
          </>
        );
      }
}


const mapStateToProps = (state, ownProps) => {
  const { ruleConfigure } = state;
  const ruleConfigureEditInfo = modelUtils.getModelEntity(ruleConfigure, "ruleConfigure@editInfo");

  const ruleConfigureSave = modelUtils.getModelEntity(ruleConfigure, "ruleConfigure@save");
  const load = modelUtils.getLoadingState(state, "ruleConfigure");
    return {
      ruleConfigureEditInfo,
      ruleConfigureSave,
    ...load
    };
  };

  export default connect(mapStateToProps)(RuleConfigureDetail);
